/**
 *
 * @module purchases
 *
 */

import Check from 'check-types';
import Exception from './../services/exception/entry';
import PurchaseManager from './purchaseManager';
import Receipt from './receipt';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class Purchases
 *
 */
export default class Purchases {

    /**
     *
     * @param {PurchaseManager} purchaseManager
     *
     */
    constructor(purchaseManager) {

        const errorMessage = {
            ctor: 'Purchases(PurchaseManager)',
            get purchaseManager() {
                return `${this.ctor} needs PurchaseManager instance`;
            }
        };

        instanceStrict(purchaseManager, PurchaseManager, errorMessage.purchaseManager, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {PurchaseManager}
         *
         */
        this.purchaseManager = purchaseManager;

    }

    /**
     *
     * @access private
     * @param {Receipt} receipt
     * @returns {Promise<AccessStatus>}
     *
     */
    redeem(receipt) {

        const errorMessage = {
            method: 'Purchases.redeem(receipt)',
            get receipt() {
                return `${this.method} needs Receipt instance`;
            }
        };

        instanceStrict(receipt, Receipt, errorMessage.receipt, InvalidArgumentException);

        return new Promise((resolve, reject) => {
            return reject(new Error('not-implemented'));
        });

    }

    /**
     *
     * @access private
     * @param {Receipt} receipt
     * @returns {Promise<AccessStatus>}
     *
     */
    restore(receipt) {

        const errorMessage = {
            method: 'Purchases.restore(receipt)',
            get receipt() {
                return `${this.method} needs Receipt instance`;
            }
        };

        instanceStrict(receipt, Receipt, errorMessage.receipt, InvalidArgumentException);

        return new Promise((resolve, reject) => {
            return reject(new Error('not-implemented'));
        });

    }

}



// WEBPACK FOOTER //
// ./src/purchase/purchases.js